import { io } from "socket.io-client";

const URL = process.env.REACT_APP_SERVER_URL || "http://localhost:4000";

export const socket = io(URL, {
  autoConnect: false,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  timeout: 20000,
});
